import { render, staticRenderFns } from "./opinionText.vue?vue&type=template&id=f17418b0&scoped=true&"
import script from "./opinionText.vue?vue&type=script&lang=js&"
export * from "./opinionText.vue?vue&type=script&lang=js&"
import style0 from "./opinionText.vue?vue&type=style&index=0&id=f17418b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17418b0",
  null
  
)

export default component.exports